import { Badge } from '@/components/ui/badge'
import { Card } from '@/components/ui/card'
import type { MemberPortalOrganization } from './MemberSignIn'
import { RosterPanel } from './MemberPortalRosterPanel'
import { displayPortalDate } from './memberPortalPresentation'

// The organization's own Organization Membership, with its Roster for a Roster manager.
export function MemberPortalOrganizationMembership({
  organization,
  canManage,
}: {
  organization: MemberPortalOrganization
  canManage: boolean
}) {
  const facts = [
    ['Level', organization.level],
    [
      'Membership term',
      organization.term_starts_on && organization.renewal_due_on
        ? `${displayPortalDate(organization.term_starts_on)} – ${displayPortalDate(organization.renewal_due_on)}`
        : null,
    ],
    [
      'Renewal due',
      organization.renewal_due_on ? displayPortalDate(organization.renewal_due_on) : null,
    ],
    [
      'Roster',
      // A Roster manager reads the count on the Roster card below.
      canManage
        ? null
        : organization.roster_cap === null
          ? `${organization.roster_count} people`
          : `${organization.roster_count} of ${organization.roster_cap} places filled`,
    ],
  ].filter((fact): fact is [string, string] => Boolean(fact[1]))
  return (
    <div className="space-y-4">
      <Card className="overflow-hidden">
        <div className="flex h-12 items-center gap-2 border-b border-border px-4">
          <h2 className="text-body font-medium">{organization.name} membership</h2>
          <Badge variant={organization.status === 'Active' ? 'success' : 'neutral'}>
            {organization.status}
          </Badge>
        </div>
        <dl className="divide-y divide-border">
          {facts.map(([label, value]) => (
            <div key={label} className="flex min-h-9 items-center gap-4 px-4 py-2 text-body-sm">
              <dt className="w-40 shrink-0 text-muted-foreground">{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      </Card>
      {canManage && <RosterPanel organization={organization} dashboard />}
    </div>
  )
}
